import React from "react";
import { Card } from "./Card";
import { Icon } from "../Icon";

const TONE_COLOR = {
  up: "var(--kr-success-700)",
  down: "var(--kr-danger-700)",
  neutral: "var(--kr-fg-muted)",
};

/**
 * KPI card del DS: eyebrow + métrica grande mono + delta.
 * - label: texto eyebrow
 * - value: número o string formateado
 * - unit: sufijo opcional ("h", "%")
 * - delta: texto de delta
 * - deltaTone: "up" | "down" | "neutral"
 * - hint: texto secundario neutro (cuando no hay delta)
 * - icon: nombre Lucide opcional para esquina superior derecha
 */
export function Stat({ label, value, unit, delta, deltaTone = "neutral", hint, icon }) {
  return (
    <Card padding={20}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 10,
        }}
      >
        <span
          style={{
            fontSize: 11,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            color: "var(--kr-fg-muted)",
            fontWeight: 600,
          }}
        >
          {label}
        </span>
        {icon && <Icon name={icon} size={16} style={{ color: "var(--kr-fg-muted)" }} />}
      </div>
      <div
        style={{
          fontFamily: "var(--kr-font-mono)",
          fontVariantNumeric: "tabular-nums",
          fontSize: 28,
          fontWeight: 600,
          letterSpacing: "-0.02em",
          color: "var(--kr-fg-strong)",
          lineHeight: 1.1,
        }}
      >
        {value}
        {unit && (
          <span
            style={{ fontSize: 14, color: "var(--kr-fg-muted)", marginLeft: 4 }}
          >
            {unit}
          </span>
        )}
      </div>
      {(delta || hint) && (
        <div
          style={{
            marginTop: 8,
            fontSize: 11,
            fontFamily: "var(--kr-font-mono)",
            color: TONE_COLOR[deltaTone] || TONE_COLOR.neutral,
          }}
        >
          {delta || hint}
        </div>
      )}
    </Card>
  );
}

export default Stat;
